import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { WA_PHYSICS } from '../core/constants';
import { computeSafeSpawnPosition } from './spawnHelper';

/**
 * Grub SS (GunBound mobile, Super Shot - Thor's Hammer): a single electric
 * ball that rolls along the terrain like the Shot 2 balls but PASSES THROUGH
 * tanks. Its fuse only starts once it first hits the ground; for the entire
 * time it overlaps a tank it electrocutes them (damage over time), and when
 * the fuse runs out it explodes. Brutal when dropped into a deep hole with the
 * enemy (especially under a Force/Tornado zone, where the DoT stacks up fast).
 */
export const WeaponGrubSS: WeaponDefinition = {
  id: 'grubSS',
  name: 'Grub SS',
  icon: 'grubSS.png',
  category: 'thrown',
  maxAmmo: 1,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const speed = (power / 100) * 750;
    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;
    const spawn = computeSafeSpawnPosition(worm, aimRad, 20, world);

    const ball = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'grubSS',
      timer: -1, // fuse starts on first terrain contact, not at launch
      landingFuse: WA_PHYSICS.GRUB_SS.FUSE,
      bounceH: WA_PHYSICS.GRUB_SS.BOUNCE_HORIZONTAL,
      bounceV: WA_PHYSICS.GRUB_SS.BOUNCE_VERTICAL,
      friction: WA_PHYSICS.GRUB_SS.FRICTION,
      windAffected: false,
      pierceWorms: true,
      explosionRadius: WA_PHYSICS.GRUB_SS.EXPLOSION_RADIUS,
      maxDamage: WA_PHYSICS.GRUB_SS.MAX_DAMAGE,
      ownerId: worm.id,
    });

    return { success: true, entities: [ball] };
  },
};
